import React, {Component} from 'react';
import Breadcrumbs from '../Breadcrumbs/Breadcrumbs'
import connect from "react-redux/es/connect/connect";
import withRouter from "react-router/es/withRouter";
import {REQUEST_FACILITIES_DATA, requestHolidayHoursData} from "../../actions/facilitiesActions";
import {REQUEST_FACILITIES_META_DATA} from "../../actions/facilitiesMetaActions";
import queryString from 'query-string';
import BlankComponent from "../BlankComponent/BlankComponent";
import Skeleton from "../Skeleton/Skeleton";
import ReactHtmlParser from 'react-html-parser';
import moment from 'moment';

const mapStateToProps = (state) => {
    return {
        rawFacilities: state.facilitiesData.rawFacilities,
        facilitiesMeta: state.facilitiesMetaData,
        holidayHours: state.holidayHoursData
    }
};

const mapDispatchToProps = dispatch => ({
    getRawFacilities: () => dispatch({type: REQUEST_FACILITIES_DATA}),
    getFacilitiesMeta: () => dispatch({type: REQUEST_FACILITIES_META_DATA}),
    getHolidayHours: (airportCode) => dispatch(requestHolidayHoursData(airportCode))
});

const convertTo12HourTime = (time) => {
    let hours = time ? time.slice(0, 2) : "";
    let minutes = time ? time.slice(2, 4) : "";
    let meridiem = (hours >= 12) ? 'p.m.' : 'a.m.';

    if (hours > 12) {
        hours = hours - 12;
    }

    if (hours === '00') {
        hours = 12;
    }

    return {
        hours,
        minutes,
        meridiem
    }
};

class FacilityDetails extends Component {

    componentDidMount() {
        if (!this.props.rawFacilities) {
            this.props.getRawFacilities();
        }

        if (!Object.keys(this.props.facilitiesMeta).length > 0) {
            this.props.getFacilitiesMeta();
        }

        let airportCode = queryString.parse(this.props.location.search).airportCode;

        this.props.getHolidayHours(airportCode);
    };

    getCurrentFacility = (rawFacilities = this.props.rawFacilities) => {
        if (rawFacilities) {
            return rawFacilities.find((facility) => {
                return facility.airportCodeIATA === queryString.parse(this.props.location.search).airportCode
            });
        } else {
            return null;
        }
    };

    shouldComponentUpdate(nextProps, nextState) {
        // Redirect to the search page
        // if specified facility wasn't found in the list of facilities
        if (!nextProps.rawFacilities) {
            return true;
        }
        if (!this.getCurrentFacility(nextProps.rawFacilities)) {
            this.props.history.push({
                pathname: `/ship/facilities`
            });
            return false
        }
        return true;
    }

    static getHoursView(operatingHour) {

        let startTime;
        let endTime;
        let is24HourFacility;

        is24HourFacility = operatingHour.is24HourFacility.toLowerCase() === "true";
        if (!is24HourFacility) {
            startTime = convertTo12HourTime(operatingHour.startTime);
            endTime = convertTo12HourTime(operatingHour.endTime);
        }

        if (is24HourFacility) {
            return (
                    <BlankComponent><span className="table__body-bold-text">24</span> hours</BlankComponent>
            );
        } else if (operatingHour.startTime === "" || operatingHour.startTime === null) {
            return (<BlankComponent><span className="table__body-bold-text">Closed</span></BlankComponent>)
        } else {
            return (<BlankComponent>
        <span
                className="table__body-bold-text">{startTime.hours}{startTime.minutes ? `:${startTime.minutes}` : ''} {startTime.meridiem}</span>
                        <span className="table__row--hours-separator">&mdash;</span>
                        <span
                                className="table__body-bold-text">{endTime.hours}{endTime.minutes ? `:${endTime.minutes}` : ''} {endTime.meridiem}</span>
                    </BlankComponent>
            )
        }
    }

    static getHolidayHoursView(holidayHour) {

        let startTime;
        let endTime;


        startTime = convertTo12HourTime(holidayHour.openLocalTimeAtStation);
        endTime = convertTo12HourTime(holidayHour.closeLocalTimeAtStation);

        if (holidayHour.startTime === "") {
            return (<BlankComponent><span className="table__body-bold-text">Closed</span></BlankComponent>)
        } else {
            return (<BlankComponent>
        <span
                className="table__body-bold-text">{startTime.hours}{startTime.minutes ? `:${startTime.minutes}` : ''}</span> {startTime.meridiem}
                        <span className="table__row--hours-separator">&mdash;</span>
                        <span
                                className="table__body-bold-text">{endTime.hours}{endTime.minutes ? `:${endTime.minutes}` : ''}</span> {endTime.meridiem}
                    </BlankComponent>
            )
        }
    }

    static getHolidaySectionView(holidayHours) {
        const DATE_TODAY = moment();
        const DATE_TODAY_PLUS_10 = moment().add(10, "days");

        let hasHours = false;

        let hours = holidayHours.map((holidayHour) => {
            let startDate = moment(holidayHour.startLocalDateTimeAtDep, "MM/DD/YYYY");
            let endDate = moment(holidayHour.endLocalDateTimeAtDep, "MM/DD/YYYY");

            let output = [];

            let incDate = startDate.clone();

            while (incDate.isSameOrBefore(endDate)) {
                if (incDate.isBetween(DATE_TODAY, DATE_TODAY_PLUS_10, "day", "[]")) {
                    hasHours = true;
                    output.push(
                            <BlankComponent key={incDate.format("MM-DD")}>
                                <div className="table__row table__row--hours">
                                    <div className="table__heading table__heading--holiday">
                                        <div className="table__heading--holiday-name">{holidayHour.remarks.toLowerCase()}</div>
                                        {incDate.format("MM/DD")}
                                    </div>
                                    <div className="table__body table__body--hours">
                                        {FacilityDetails.getHolidayHoursView(holidayHour)}
                                    </div>
                                </div>
                            </BlankComponent>);
                }
                incDate.add(1, "days");
            }

            return output;
        });

        if (hasHours) {
            return (<BlankComponent>
                <h4 className="facility-details__third-level-title mtm pts">Holiday Hours</h4>

                <div className="table table--hours">
                    {hours}
                </div>
            </BlankComponent>)
        }
    }

    getFacilityView = (facility) => {

        const commonAirportName = facility.commonAirportName;
        const airportCodeIATA = facility.airportCodeIATA;
        const cityName = facility.facilityInfo.location.cityName;
        const stateName = facility.facilityInfo.location.stateName;
        const countryCode = facility.facilityInfo.location.countryName;
        const facilityName = facility.facilityInfo.facilityName;
        const address1 = facility.facilityInfo.location.streetAddress1;
        const address2 = facility.facilityInfo.location.streetAddress2 ? facility.facilityInfo.location.streetAddress2 : null;
        const address3 = facility.facilityInfo.location.streetAddress3 ? facility.facilityInfo.location.streetAddress3 : null;
        const zipcode = facility.facilityInfo.location.zipCode.length > 5 ? facility.facilityInfo.location.zipCode.substring(0,5) + "-" + facility.facilityInfo.location.zipCode.substring(5) : facility.facilityInfo.location.zipCode;
        const phoneNumber = facility.facilityInfo.location.phoneNumber.replace(/(\d{1})(\d{3})(\d{3})(\d)/, "+$1 ($2) $3 - $4");
        const faxNumber = facility.facilityInfo.location.faxNumber ? facility.facilityInfo.location.faxNumber.replace(/(\d{1})(\d{3})(\d{3})(\d)/, "+$1 ($2) $3 - $4") : null;

        let domesticNFGCutOffTime = "";
        let domesticNFGRecoveryTime = "";
        let domesticSSCutOffTime = "";
        let domesticSSRecoveryTime = "";
        let domesticFFCutOffTime = "";
        let domesticFFRecoveryTime = "";
        let internationalNFGCutOffTime = "";
        let internationalNFGRecoveryTime = "";
        let internationalSSCutOffTime = "";
        let internationalSSRecoveryTime = "";

        const hasCooler = facility.facilityInfo.facilityCapabilityInfo.facilityResources.split(",").indexOf("COOLER") > -1 ? "Yes" : "No";

        let holidayHours = [];

        if (this.props.holidayHours[airportCodeIATA] && this.props.holidayHours[airportCodeIATA].facilityInfo.holidayOperatingHours) {
            holidayHours = this.props.holidayHours[airportCodeIATA].facilityInfo.holidayOperatingHours;
        }

        if (this.props.holidayHours[airportCodeIATA] && this.props.holidayHours[airportCodeIATA].facilityHandlingTime) {
            if (this.props.holidayHours[airportCodeIATA].facilityHandlingTime.domesticHandlingTime) {
                domesticNFGCutOffTime = this.props.holidayHours[airportCodeIATA].facilityHandlingTime.domesticHandlingTime.nfgCutOffTime;
                domesticNFGRecoveryTime = this.props.holidayHours[airportCodeIATA].facilityHandlingTime.domesticHandlingTime.nfgRecoveryTime;
                domesticSSCutOffTime = this.props.holidayHours[airportCodeIATA].facilityHandlingTime.domesticHandlingTime.ssCutOffTime;
                domesticSSRecoveryTime = this.props.holidayHours[airportCodeIATA].facilityHandlingTime.domesticHandlingTime.ssRecoveryTime;
                domesticFFCutOffTime = this.props.holidayHours[airportCodeIATA].facilityHandlingTime.domesticHandlingTime.ffCutOffTime;
                domesticFFRecoveryTime = this.props.holidayHours[airportCodeIATA].facilityHandlingTime.domesticHandlingTime.ffRecoveryTime;
            }

            if (this.props.holidayHours[airportCodeIATA].facilityHandlingTime.internationalHandlingTime) {
                internationalNFGCutOffTime = this.props.holidayHours[airportCodeIATA].facilityHandlingTime.internationalHandlingTime.nfgCutOffTime;
                internationalNFGRecoveryTime = this.props.holidayHours[airportCodeIATA].facilityHandlingTime.internationalHandlingTime.nfgRecoveryTime;
                internationalSSCutOffTime = this.props.holidayHours[airportCodeIATA].facilityHandlingTime.internationalHandlingTime.ssCutOffTime;
                internationalSSRecoveryTime = this.props.holidayHours[airportCodeIATA].facilityHandlingTime.internationalHandlingTime.ssRecoveryTime;
            }
        }

        let facilityType = "";

        let facilityTypeCss = "facility-details-badge__hidden";

        if (facility.facilityInfo.facilityType === "RFS") {
            facilityType = "Road Feeder Service";
            facilityTypeCss = "facility-details-badge__RFS";
        } else if (facility.facilityInfo.facilityType === "INTERLINE") {
            facilityType = "Interline";
            facilityTypeCss = "facility-details-badge__INTERLINE";
        }

        let contacts = [];

        let internationalRestrictions = [];
        let internationalAcceptance = [];

        let domesticRestrictions = [];
        let domesticAcceptance = [];

        let facilityAlertMessage = "";
        let feederSchedule = [];
        let dropPoints = [];
        let feederHeading = "";
        let feederFooter = "";

        if (Object.keys(this.props.facilitiesMeta).length) {
            contacts = this.props.facilitiesMeta.contacts.filter(meta => {
                return meta.manages.indexOf(airportCodeIATA) > -1;
            });

            let facilityMeta = this.props.facilitiesMeta.facilities.find(item => {
                return item.airportCode === airportCodeIATA;
            });

            if (facilityMeta) {
                internationalAcceptance = facilityMeta.international.acceptance;
                internationalRestrictions = facilityMeta.international.restriction;
                domesticRestrictions = facilityMeta.domestic.restriction;
                domesticAcceptance = facilityMeta.domestic.acceptance;
                facilityAlertMessage = facilityMeta.alertMessage;
                feederHeading = facilityMeta.feederHeading;
                feederFooter = facilityMeta.feederFooter;
                feederSchedule = facilityMeta.feederSchedule;
                dropPoints = facilityMeta.dropPoints;
            }
        }

        return (
                <div className="wrapper">
                    <Breadcrumbs pageTitle={`${commonAirportName} (${airportCodeIATA})`}/>
                    {facilityAlertMessage ? <div className="facility-details__alert-message mtl">
                        <div className="facility-details__alert-icon">
                            <img
                                    src="./assets/icons/alert-red.svg" alt=""/>
                        </div>
                        <div className="facility-details__alert-message-text">
                            {ReactHtmlParser(facilityAlertMessage)}</div>
                    </div> : null}
                    <div className="facility-details-heading__title">
                        <h1 className="facility-details__title">{airportCodeIATA} - <span
                                style={{textTransform: "capitalize"}}>{commonAirportName}</span></h1>
                        <div className={facilityTypeCss}>{facilityType}</div>
                    </div>
                    <div className="facility-details__info-box">
                        <div className="facility-details__general-information">
                            <div className="facility-details__address-info">
                                <h2 className="facility-details__name">{facilityName}</h2>
                                <p className="facility-details__address">{address1}</p>
                                {address2 ? <p className="facility-details__address">{address2}</p> : null}
                                {address3 ? <p className="facility-details__address">{address3}</p> : null}
                                <p className="facility-details__address">{cityName}, {stateName} {zipcode}</p>
                            </div>
                            <div className="facility-details__phone-info">
                                <p className="facility-details__address facility-details__address--spaced-top">
                                    <span className="text-bold">Tel </span> <a href={`tel:${phoneNumber}`}>{phoneNumber}</a>
                                </p>
                                <p className="facility-details__address facility-details__address--spaced-bottom">
                                    {faxNumber ? <BlankComponent><span className="text-bold">Fax </span> <a
                                            href={`tel:${faxNumber}`}>{faxNumber}</a></BlankComponent> : null}
                                </p>
                            </div>
                        </div>

                    </div>
                    <h5 className="facility-details__second-level-title">Hours</h5>
                    <h4 className="facility-details__third-level-title mtm pts">Facility Hours</h4>
                    <div className="table table--hours">
                        {
                            facility.facilityInfo.operatingHours.map((operatingHour, index) => {
                                return (
                                        <BlankComponent key={index}>
                                            <div className="table__row table__row--hours">
                                                <div className="table__heading">{operatingHour.dayOfWeek}</div>
                                                <div className="table__body table__body--hours">
                                                    {FacilityDetails.getHoursView(operatingHour)}
                                                </div>
                                            </div>
                                        </BlankComponent>
                                )
                            })
                        }
                    </div>
                    {FacilityDetails.getHolidaySectionView(holidayHours)}

                    <h5 className="facility-details__second-level-title">Information</h5>
                    <div className="facility-details__information-container">
                        {countryCode === 'US' &&
                        <div className="facility-details__information-item facility-details__information-item--spaced">
                            <h4 className="facility-details__third-level-title mtm pts">Domestic</h4>
                            <div className="table mts">
                                <div className="table__row table__row--information">
                                    <div className="table__heading">Cutoff time* (min)</div>
                                    <div className="table__bodyColumn-facility">
                                        <div className="table__body-facility">
                                            <span className="bold-text-left-align-facility">NFG</span>
                                            <span className="bold-text-right-align-facility">{domesticNFGCutOffTime}</span>
                                        </div>
                                        <div className="table__body-facility">
                                            <span className="bold-text-left-align-facility">FRESH FAST</span>
                                            <span className="bold-text-right-align-facility">{domesticFFCutOffTime}</span>
                                        </div>
                                        <div className="table__body-facility">
                                            <span className="bold-text-left-align-facility">SOUTHWEST STANDARD</span>
                                            <span className="bold-text-right-align-facility">{domesticSSCutOffTime}</span>
                                        </div>
                                     </div>
                                </div>
                                <div className="table__row table__row--information">
                                    <div className="table__heading">Recovery time* (min)</div>
                                    <div className="table__bodyColumn-facility">
                                        <div className="table__body-facility">
                                            <span className="bold-text-left-align-facility">NFG</span>
                                            <span className="bold-text-right-align-facility">{domesticNFGRecoveryTime}</span>
                                        </div>
                                        <div className="table__body-facility">
                                            <span className="bold-text-left-align-facility">FRESH FAST</span>
                                            <span className="bold-text-right-align-facility">{domesticFFRecoveryTime}</span>
                                        </div>
                                        <div className="table__body-facility">
                                            <span className="bold-text-left-align-facility">SOUTHWEST STANDARD</span>
                                            <span className="bold-text-right-align-facility">{domesticSSRecoveryTime}</span>
                                        </div>
                                     </div>
                                </div>
                                <div className="table__row table__row--information">
                                    <div className="table__heading">Cooler</div>
                                    <div className="table__bodyColumn-facility">
                                        <div className="table__bodyColumnCentered-facility">
                                            <span className="table__bodyColumnCentered-bold-text">{hasCooler}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                {
                                    domesticAcceptance.length > 0 ?
                                            <div className="mtm">
                                                <span className="facility-details__acceptance-restriction">Acceptance:</span>
                                                {
                                                    domesticAcceptance.map((r, index) => {
                                                        return (<p key={index}> {ReactHtmlParser(r)}</p>)
                                                    })}
                                            </div>
                                            : null
                                }
                                {
                                    domesticRestrictions.length > 0 ?
                                            <div className="mtm">
                                                <span className="facility-details__acceptance-restriction">Restrictions:</span>
                                                {
                                                    domesticRestrictions.map((r, index) => {
                                                        return (<p key={index}> {ReactHtmlParser(r)}</p>)
                                                    })}
                                            </div>
                                            : null
                                }
                            </div>
                        </div>}
                        <div className="facility-details__information-item">
                            <h4 className="facility-details__third-level-title mtm pts">International</h4>
                            <div className="table mts">
                                <div className="table__row table__row--information">
                                    <div className="table__heading">Cutoff time* (Min)</div>
                                    <div className="table__bodyColumn-facility">
                                        <div className="table__body-facility">
                                            <span className="bold-text-left-align-facility">NFG</span>
                                            <span className="bold-text-right-align-facility">{internationalNFGCutOffTime}</span>
                                        </div>
                                        <div className="table__body-facility">
                                            <span className="bold-text-left-align-facility">SOUTHWEST STANDARD</span>
                                            <span className="bold-text-right-align-facility">{internationalSSCutOffTime}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="table__row table__row--information">
                                    <div className="table__heading">Recovery time* (min)</div>
                                    <div className="table__bodyColumn-facility">
                                        <div className="table__body-facility">
                                            <span className="bold-text-left-align-facility">NFG</span>
                                            <span className="bold-text-right-align-facility">{internationalNFGRecoveryTime}</span>
                                        </div>
                                        <div className="table__body-facility">
                                            <span className="bold-text-left-align-facility">SOUTHWEST STANDARD</span>
                                            <span className="bold-text-right-align-facility">{internationalSSRecoveryTime}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="table__row table__row--information">
                                    <div className="table__heading">Cooler</div>
                                    <div className="table__bodyColumn-facility">
                                        <div className="table__bodyColumnCentered-facility">
                                            <span className="table__bodyColumnCentered-bold-text">{hasCooler}</span>
                                        </div>
                                     </div>
                                </div>
                            </div>
                            <div>

                                {
                                    internationalAcceptance.length > 0 ?
                                            <div className="mtm">
                                                <span className="facility-details__acceptance-restriction">Acceptance: </span>
                                                {
                                                    internationalAcceptance.map((r, index) => {
                                                        return (<p key={index}> {ReactHtmlParser(r)}</p>)
                                                    })}
                                            </div>
                                            : null
                                }
                                {
                                    internationalRestrictions.length > 0 ?
                                            <div className="mtm">
                                                <span className="facility-details__acceptance-restriction">Restrictions: </span>
                                                {
                                                    internationalRestrictions.map((r, index) => {
                                                        return (<p key={index}> {ReactHtmlParser(r)}</p>)
                                                    })}
                                            </div>
                                            : null
                                }
                            </div>
                        </div>
                    </div>
                    <p className="facility-details__annotation"><span className="text-bold">* Cutoff time</span>: Minimum drop-off
                        time (in minutes) before flight departure by product. Cutoff times do not include processing and screening.
                        All processing and screening procedures need to be completed prior to the posted cutoff time.<span
                                className="text-bold">Recovery time:</span> Minimum time for cargo to be taken off plane/availability.</p>
                    {
                        feederSchedule && feederSchedule.length > 0 ?
                                <div className="facility-details__information-item">
                                    <h5 className="facility-details__second-level-title mtm pts">Road Feeder Service</h5>
                                    <div className="facility-details__third-level-title mtm pts">{feederHeading}</div>
                                    <div className="table mts">
                                        <div className="table__row table__row--feeder">
                                            <div className="table__heading">From</div>
                                            {
                                                feederSchedule.map((schedule, index) => {
                                                    return (<div className="table__body table__body--feeder"><span
                                                            className="table__body-bold-text">{schedule.from}</span>
                                                    </div>)
                                                })
                                            }
                                        </div>
                                        <div className="table__row table__row--feeder">
                                            <div className="table__heading">To</div>
                                            {
                                                feederSchedule.map((schedule, index) => {
                                                    return (<div className="table__body table__body--feeder"><span
                                                            className="table__body-bold-text">{schedule.to}</span>
                                                    </div>)
                                                })
                                            }
                                        </div>
                                        <div className="table__row table__row--feeder">
                                            <div className="table__heading">Departs</div>
                                            {
                                                feederSchedule.map((schedule, index) => {
                                                    return (<div className="table__body table__body--feeder"><span
                                                            className="table__body-bold-text">{schedule.departs}</span>
                                                    </div>)
                                                })
                                            }
                                        </div>
                                        <div className="table__row table__row--feeder">
                                            <div className="table__heading">Arrives</div>
                                            {
                                                feederSchedule.map((schedule, index) => {
                                                    return (<div className="table__body table__body--feeder"><span
                                                            className="table__body-bold-text">{schedule.arrives}</span>
                                                    </div>)
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>
                                : null
                    }

                    {
                        dropPoints && dropPoints.length > 0 ?
                                <div className="facility-details__information-item">
                                    <div className="facility-details__third-level-title mtm pts">Drop Points</div>
                                    <div className="table mts div__table-large-screens-hide-show">
                                        <div className="table__row table__row--feeder">
                                            <div className="table__heading">Location</div>
                                            {
                                                dropPoints.map((point, index) => {
                                                    return (<div className="table__body table__body--feeder"><span
                                                            className="table__body-bold-text">{point.location}</span>
                                                    </div>)
                                                })
                                            }
                                        </div>
                                        <div className="table__row table__row--feeder">
                                            <div className="table__heading">Address</div>
                                            {
                                                dropPoints.map((point, index) => {
                                                    return (<div className="table__body table__body--feeder"><span
                                                            className="table__body-bold-text">{point.address}</span>
                                                    </div>)
                                                })
                                            }
                                        </div>
                                        <div className="table__row table__row--feeder">
                                            <div className="table__heading">Hours of Operation</div>
                                            {
                                                dropPoints.map((point, index) => {
                                                    return (<div className="table__body table__body--feeder"><span
                                                            className="table__body-bold-text">{point.hoursOfOperation}</span>
                                                    </div>)
                                                })
                                            }
                                        </div>
                                    </div>
                                    <table className="table__drop-points mts">
                                        <tr>
                                            <th className="table_drop-points__heading">Location</th>
                                            <th className="table_drop-points__heading">Address</th>
                                            <th className="table_drop-points__heading">Hours Of Operation</th>
                                        </tr>

                                        {
                                            dropPoints.map((point, index) => {
                                                return (
                                                        <tr>
                                                            <td className="table_drop-points__body table__drop-points-bold-text">{point.location}</td>
                                                            <td className="table_drop-points__body table__drop-points-bold-text">{point.address}</td>
                                                            <td className="table_drop-points__body table__drop-points-bold-text">{point.hoursOfOperation}</td>
                                                        </tr>
                                                )
                                            })
                                        }
                                    </table>
                                    < p className="mts"> {feederFooter}</p>
                                </div>
                                : null
                    }
                    <div className="facility-details__managers">
                        {contacts.map(contact => {
                            return (
                                    <div key={contact.email} className="facility-details__manager">
                                        <p className="contact-section__info-block-subtitle">{contact.title}</p>
                                        <p className="contact-sales-name">{contact.name}</p>
                                        <p className="contact-sales-cell"><a href={"tel:+" + contact.phone}>{contact.phone}</a></p>
                                        <p className="contact-sales-email"><a href={"mailto:" + contact.email}>{contact.email}</a></p>
                                    </div>
                            )
                        })}
                    </div>
                </div>
        )
    };

    render() {
        const facility = this.getCurrentFacility();
        return facility ? this.getFacilityView(facility) : <Skeleton type="LONG_CONTENT_PAGE"/>;
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FacilityDetails));



// WEBPACK FOOTER //
// ./src/components/FacilityDetails/FacilityDetails.js